
















import {Component, Prop, Vue} from 'vue-property-decorator';
import BookletTile from '@/components/ui/BookletTile.vue';
import BoxTile from '@/components/ui/BoxTile.vue';
import {SET_LAYOUT_CONFIG} from "@/store/layout_module";
import Booklet from "@/models/booklet";

@Component({
    components: {
        BoxTile,
        BookletTile
    },
})
export default class Booklets extends Vue {

    @Prop()
    public goalid!: string;

    get goalDetails() {
        return this.$store.getters.goalDetailById(this.goalid);
    }

  get latestGoal() {
    if (this.$store.state.data) {
      if (this.$store.state.data.goals && this.$store.state.data.goals.length) {
        return this.$store.state.data.goals[0].goalKey
      }
      return 'latest';
    }
    return 'latest';
  }

    get primaryBooklets() {
        return this.booklets.filter((el: any) => {
            return el.is_primary;
        })
    }

    get otherBooklets() {
        return this.booklets.filter((el: any) => {
            return !el.is_primary;
        })
    }

    get booklets() {

        const goal = this.goalDetails;

        if (goal && goal.details &&
            goal.details.promptGoalBooklets &&
            goal.details.promptGoalBooklets.length) {
            return goal.details.promptGoalBooklets
        }
        return [];
    }


    public updatePageTitle() {
        /**
         * If the id is not `latest`, then we are viewing booklets for a past goal
         * So the TitleBar should display the back button linking to that goal page
         */

        this.$store.commit('layout/' + SET_LAYOUT_CONFIG, {
            showPageTitle: true,
            showBackButton: this.goalid !== this.latestGoal,
            pageTitle: 'BOOKLETS.PAGE_TITLE',
            pageTitleParams: null,
            backButtonLink: {name: 'dashboard.goals.goal', params: {id: this.goalid}},
            showFooterNav: true
        })
    }

    private updated() {
        this.updatePageTitle();
    }

    private mounted() {
        this.updatePageTitle();
    }

}
